import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { DotNotification } from 'virtues-bootstrap';

import { ReactComponent as IconClipboardList } from 'svg/clipboard-list-solid.svg';

import s from './styles.module.scss';

const HistoryListItem = ({ children, dot, id }) => (
  <NavLink
    activeClassName={s.active}
    className={s.historyListItem}
    to={`/report/${id}`}
    data-test={`reportHistoryItem-${id}`}
  >
    {dot && <DotNotification className={s.dot} />}
    <div className={s.icon}>
      <IconClipboardList />
    </div>
    <div className={s.date}>{children}</div>
  </NavLink>
);

HistoryListItem.propTypes = {
  children: PropTypes.string.isRequired,
  dot: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

export default withRouter(HistoryListItem);
